import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
var _dec, _class, _class2;
/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { IconStarSolid, IconEmptyLine } from '@instructure/ui-icons';
import { Text } from '@instructure/ui-text';
import { Pill } from '@instructure/ui-pill';
import t from 'format-message';
import { withStyle, jsx } from '@instructure/emotion';
import { outcomeResultShape, scoringMethodShape, scoringTierShape, stylesShape } from "../../../store/shapes.js";
import convertToPoints from "../convertToPoints.js";
import generateComponentTheme from "../../theme.js";
import generateStyle from "./styles.js";
var valueBetweenTiers = function valueBetweenTiers(value, upperTier, lowerTier) {
  if (upperTier && value > upperTier.percent) {
    return false;
  }
  if (lowerTier && value <= lowerTier.percent) {
    return false;
  }
  return true;
};
var renderTier = function renderTier(scoringMethod, tier, styles) {
  return jsx("div", {
    key: tier.id,
    css: styles.scoringTier,
    "data-automation": "outcomeView__scoringTier"
  }, jsx("div", {
    css: styles.rating
  }, jsx("div", {
    css: styles.score,
    className: "outcomeViewScore",
    "data-automation": "outcomeView__score"
  }, jsx(Text, {
    size: "medium"
  }, convertToPoints(tier.percent, scoringMethod))), jsx("div", {
    css: styles.description,
    "data-automation": "outcomeView__description"
  }, jsx(Text, {
    size: "small"
  }, tier.description))), tier.count != null && jsx("div", {
    css: styles.masteryCount,
    "data-automation": "outcomeView__masteryCount"
  }, jsx(Text, {
    size: "small"
  }, t("{count, plural,\n                one {1 Student}\n                other {# Students}\n              }", {
    count: tier.count
  }))));
};
var ScorePill = function ScorePill(_ref) {
  var className = _ref.className,
    icon = _ref.icon,
    text = _ref.text,
    variant = _ref.variant,
    styles = _ref.styles,
    method = _ref.method;
  var outerStyle = _objectSpread(_objectSpread({}, styles.pill), className);
  return jsx("span", {
    css: outerStyle,
    "data-automation": "outcomeView__".concat(variant, "Pill"),
    className: "outcomeView".concat(method)
  }, icon, "\xA0", jsx(Pill, {
    color: variant
  }, text));
};

// eslint-disable-next-line immutable/no-mutation
ScorePill.propTypes = {
  className: PropTypes.object.isRequired,
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  variant: PropTypes.string.isRequired,
  styles: PropTypes.object.isRequired,
  method: PropTypes.string.isRequired
};
var renderGap = function renderGap(styles, scoringMethod, outcomeResult, upperTier, lowerTier) {
  var mastery = scoringMethod.mastery_percent;
  var average = outcomeResult ? outcomeResult.averageScore : null;
  var components = [valueBetweenTiers(mastery, upperTier, lowerTier) && jsx(ScorePill, {
    key: "mastery",
    text: "MASTERY ".concat(convertToPoints(mastery, scoringMethod), " PTS"),
    className: styles.mastery,
    variant: "success",
    icon: jsx(IconStarSolid, {
      "data-automation": "outcomeView__masteryStar"
    }),
    styles: styles,
    method: "Mastery"
  })];
  if (average !== null) {
    components.push(valueBetweenTiers(average, upperTier, lowerTier) && jsx(ScorePill, {
      key: "average",
      text: "AVG. SCORE ".concat(convertToPoints(average, scoringMethod), " PTS"),
      className: styles.average,
      variant: "info",
      icon: jsx(IconEmptyLine, null),
      styles: styles,
      method: "Average"
    }));
  }
  return jsx("div", {
    css: styles.gap,
    className: "outcomeViewGap"
  }, average !== null && average <= mastery ? components : components.reverse());
};
var ScoringTiers = (_dec = withStyle(generateStyle, generateComponentTheme), _dec(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
  _inherits(ScoringTiers, _React$Component);
  var _super = _createSuper(ScoringTiers);
  function ScoringTiers() {
    _classCallCheck(this, ScoringTiers);
    return _super.apply(this, arguments);
  }
  _createClass(ScoringTiers, [{
    key: "render",
    value: function render() {
      var _this = this;
      var _this$props = this.props,
        outcomeResult = _this$props.outcomeResult,
        scoringTiers = _this$props.scoringTiers,
        scoringMethod = _this$props.scoringMethod;
      return jsx("div", {
        "data-automation": "outcomeView__scoringTiers"
      }, renderGap.apply(void 0, [this.props.styles, scoringMethod, outcomeResult, null].concat(_toConsumableArray(scoringTiers.slice(0, 1)))), scoringTiers.map(function (tier, i) {
        return [renderTier(scoringMethod, tier, _this.props.styles), renderGap.apply(void 0, [_this.props.styles, scoringMethod, outcomeResult].concat(_toConsumableArray(scoringTiers.slice(i, i + 2))))];
      }));
    }
  }]);
  ScoringTiers.displayName = "ScoringTiers";
  return ScoringTiers;
}(React.Component), _class2.propTypes = {
  scoringTiers: PropTypes.arrayOf(scoringTierShape).isRequired,
  scoringMethod: scoringMethodShape.isRequired,
  outcomeResult: outcomeResultShape,
  styles: stylesShape
}, _class2.defaultProps = {
  outcomeResult: null
}, _class2)) || _class);
export { ScoringTiers as default };